const ASSIGNMENT_TYPES = ['forest-operation', 'silviculture', 'registration', 'supply-wood'] as const
const LAST_ASSIGNMENT_KEY = 'lastAssignmentPage'

export default defineNuxtRouteMiddleware((to) => {

    if (to.path === '/') {
        const lastAssignment = import.meta.client
            ? (localStorage.getItem(LAST_ASSIGNMENT_KEY) ?? 'forest-operation')
            : 'forest-operation'
        const target = ASSIGNMENT_TYPES.includes(lastAssignment as typeof ASSIGNMENT_TYPES[number])
            ? lastAssignment
            : 'forest-operation'
        return navigateTo(`/assignments/${target}`)
    }

    // Remember the last visited assignment sub-page
    if (import.meta.client && to.path.startsWith('/assignments/')) {
        const type = to.path.split('/')[2]
        if (type && ASSIGNMENT_TYPES.includes(type as typeof ASSIGNMENT_TYPES[number])) {
            localStorage.setItem(LAST_ASSIGNMENT_KEY, type)
        }
    }
})

